import { render, staticRenderFns } from "./AirFreightPage.vue?vue&type=template&id=61662a39&"
import script from "./AirFreightPage.vue?vue&type=script&lang=js&"
export * from "./AirFreightPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports